import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ExecuteLightningWithdrawalInternalActionRequest } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/public.pb'
import { ExecuteLightningWithdrawalInternalActionResponse } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/public.pb'

export const executeLightningWithdrawalInternalAction = (
  request: ExecuteLightningWithdrawalInternalActionRequest,
  options?: CashRequestOptions
) =>
  post<ExecuteLightningWithdrawalInternalActionRequest, ExecuteLightningWithdrawalInternalActionResponse>(
    '/2.0/cash/execute-lightning-withdrawal-internal-action',
    request,
    { ...options, rejectOnError: true }
  )
